module.exports = __webpack_public_path__ + "static/media/Template_urgent_regular_site.9f4c45e3.csv";